<template>
  <div>
    <div class="statuses-block">
      <div class="status-block">
        <div class="dot active-status" />
        <div class="status-name">
          {{ 'In Progress' | i18n }}
        </div>
      </div>
      <div class="status-block">
        <div class="dot finished-status" />
        <div class="status-name">
          {{ 'Completed' | i18n }}
        </div>
      </div>
    </div>
    <Table
      :update="loadReports"
      :columns="columns"
      :rows="reports"
      :filter="filter"
      :update-filter="updateFilter"
      :loading-instance="loadingInstance"
      :set-loading-instance="setLoadingInstance"
      tableName="administrationReportsTable"
    />
  </div>
</template>

<script>
import moment from 'moment';
import { ReportsMixin, NotificationMixin, DeleteRowMixin } from '../../../../../mixins';
import { REPORT_STATUSES } from '../../../../../../../../constants';
import Table from '../../../common/table';

export default {
  name: 'Reports',
  components: { Table },
  mixins: [ReportsMixin, NotificationMixin, DeleteRowMixin],
  props: {
    getReports: {
      type: Function,
      default: () => {}
    },
    caseIds: {
      type: Array,
      default: () => []
    }
  },
  data: function() {
    return {
      reports: [],
      loadingInstance: null,
      filter: {
        page: 1,
        limit: 10,
        totalCount: 0,
        sortBy: 'updatedAt',
        sortOrder: 'desc'
      },
      columns: [
        {
          field: 'status',
          title: '',
          key: '1',
          width: 30,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            const cellData = row[column.field];
            const color = (() => {
              switch (cellData) {
                case REPORT_STATUSES.IN_PROGRESS:
                  return 'active';
                case REPORT_STATUSES.COMPLETED:
                  return 'finished';
              }
            })();
            return <div class={`status-cell ${color}-status`}></div>;
          }
        },
        {
          field: 'caseNumber',
          title: this.$translate('Case'),
          key: '2',
          sortBy: '',
          align: 'left',
        },
        {
          field: 'createdAt',
          title: this.$translate('Created At'),
          key: '3',
          sortBy: ''
        },
        {
          field: 'createdByEmail',
          title: this.$translate('Created by user'),
          key: '4'
        },
        {
          field: 'updatedAt',
          title: this.$translate('Last Update'),
          key: '5',
          sortBy: 'desc'
        },
        {
          field: 'details',
          title: '',
          key: '6',
          width: 400,
          renderBodyCell: ({ row }, h) => {
            return (
              <div class="download-buttons">
                <div class="download-button" on-click={() => this.restoreReport(row)}>
                  { this.$translate('restore_report') }
                </div>
                <div class="download-button delete-button" on-click={() => this.hardDelete(row.id)}>
                  { this.$translate('permanently_delete') }
                </div>
              </div>
            );
          }
        }
      ]
    };
  },
  methods: {
    async loadReports() {
      try {
        this.startLoading();
        const response = await this.getReports(this.filter);
        this.reports = response.data.map(item => ({
          ...item,
          createdByEmail: item.createdBy ? item.createdBy.email : '',
          createdAt: moment(item.createdAt).format('DD.MM.YY HH:mm'),
          updatedAt: moment(item.updatedAt).format('DD.MM.YY HH:mm')
        }));
        this.stopLoading();
      } catch (err) {
        this.showNotification({ type: 'error', message: err.message });
      }
    },
    async restoreReport(report) {
      try {
        const caseDeleted = this.caseIds.includes(report.caseId);
        if (caseDeleted) {
          return this.showNotification({
            type: 'error',
            message: this.$translate("You can't restore report if case deleted. At first restore case")
          });
        }
        console.log(report, 'report');
        this.startLoading();
        await this.reportsService.restoreReport(report.id);
        this.loadReports();
        this.showNotification({ type: 'success', title: this.$translate('success'), message: this.$translate('success') });
      } catch (err) {
        this.stopLoading();
        this.showNotification({ type: 'error', message: err.message });
      }
    },
    async hardDelete(id) {
      await this.deleteSelectedRows(null, async () => {
        try {
          this.startLoading();
          await this.reportsService.hardDeleteReport(id);
          this.loadReports();
        } catch (err) {
          this.stopLoading();
          this.showNotification({ type: 'error', message: err.message });
        }
      });
    },
    updateFilter(f) {
      this.filter = {
        ...this.filter,
        ...f
      };
    },
    setLoadingInstance(loadingInstance) {
      this.loadingInstance = loadingInstance;
    },
    startLoading() {
      this.loadingInstance.show();
    },
    stopLoading() {
      this.loadingInstance.close();
    }
  }
};
</script>

<style lang="scss" scoped>
.img-wrapper {
  padding-top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.img-preview {
  width: 100%;
  box-shadow: 0px 0px 20px 1px rgba(0, 0, 0, 0.21);
}

::v-deep  .download-buttons {
  display: flex;
  justify-content: space-around;
}
::v-deep  .download-button {
  background: rgb(237, 248, 254);
  border: 2px solid rgb(175, 216, 255);
  border-radius: 4px;
  padding: 2px 13px;
  margin: 0px 5px;
  color: rgb(49, 141, 255);
  cursor: pointer;
}
::v-deep .status-cell {
  position: absolute;
  top: 0;
  left: 0;
  width: 5px;
  height: 100%;
  border-radius: 0 2px 2px 0;
}
::v-deep  .dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}
::v-deep  .active-status {
  background-color: rgb(37, 154, 43);
}
::v-deep  .inprogress-status {
  background-color: rgb(239, 255, 15);
}
::v-deep  .finished-status {
  background-color: rgb(90, 98, 107);
}

.statuses-block {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
  width: 100%;
}

.status-block {
  display: flex;
  margin-left: 20px;
  align-content: center;
  justify-content: center;
  align-items: center;
}

.status-name {
  margin-left: 10px;
}

::v-deep  .delete-button {
  border-color: #db474f;
  background: rgb(219, 71, 79);
  color: white;
}
</style>
